import type { FormatDateOptions, FormatNumberOptions } from 'react-intl';

export const CURRENCY_2_DECIMALS: FormatNumberOptions = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
  style: 'currency',
};
export const CURRENCY_2_DECIMALS_ALWAYS: FormatNumberOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  style: 'currency',
};

export const CURRENCY_NO_DECIMALS: FormatNumberOptions = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
  style: 'currency',
};

export const DATE_FORMAT: FormatDateOptions = {
  day: '2-digit',
  month: 'long',
  year: 'numeric',
};
